import { render } from "./QuickActionsSection.vue?vue&type=template&id=663b1426"
import script from "./QuickActionsSection.vue?vue&type=script&lang=js"
export * from "./QuickActionsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__